import React, { useState } from 'react'
import './Nav.css'
import { Link } from 'gatsby'

function Nav () {
  const [ isOpen, setIsOpen ] = useState(false)
  const drawerClass = isOpen ? 'drawer open' : 'drawer'
  return (
    <div className='main-nav'>
      <button className='menu-button' onClick={() => setIsOpen(true)}>
          &larr; Menu
      </button>
      <div className={drawerClass}>
        <nav>
          <h2>Menu</h2>
          <button className='close' onClick={() => setIsOpen(false)}>X</button>
          <ul>
            <li><Link to='/'>Home</Link></li>
            <li><Link to='/updates'>Updates</Link></li>
            <li><Link to='/import-export'>Import / Export</Link></li>
          </ul>
        </nav>
      </div>
    </div>
  )
}

export default Nav
